import { Tag, type TagColor } from '@leland-dev/leland-ui-library';
import Image from 'next/image';
import { type FC } from 'react';

export interface OrganizationTagDetails {
  organization: {
    name: string;
    logoLink?: Nullable<string>;
  };
  text?: string;
  tagColor?: TagColor;
}

interface OrganizationTagProps {
  tagDetails: OrganizationTagDetails;
  className?: string;
}

const OrganizationTag: FC<OrganizationTagProps> = ({
  tagDetails,
  className,
}) => {
  return (
    <div className={className}>
      <Tag
        CustomLeftIcon={() => (
          <Image
            className="rounded-full"
            width={24}
            height={24}
            src={tagDetails.organization.logoLink ?? ''}
            alt=""
          />
        )}
        text={tagDetails.text ?? tagDetails.organization.name}
        tagColor={tagDetails.tagColor}
      />
    </div>
  );
};

export default OrganizationTag;
